module.exports = __webpack_public_path__ + "static/media/logoEstado.e0c9d57c.png";